module.exports = __webpack_public_path__ + "media/images/favicon-16x16-5915e5a1.png";